

// import React from 'react'
// import Banner from "../Component/BannerHome"
// import Landingabout from "../Component/Modules/Landingmanagment/Landingabout";
// import Landingbanner from "../Component/Modules/Landingmanagment/Landingbanner";
// import "./Homes.css";
// import { Link } from "react-router-dom";
// function Homes() {
//   return (
//     <div>
  
//       <div className='col-lg-12 home-banner-scrolling' style={{ marginTop: "105px", marginBottom: "50px", overflow: "auto", scrollbarWidth: "none" }}>
//         {/* <p
//           className="breadcrumb maamaas-home-bredcum or7"
//           style={{
//             position: "fixed",
//             top: "64px",
//             left: "18vw",
//             width: "100%",
//             backgroundColor: "#fff",
//             padding: "10px 0",
//             fontSize: "18px",
//             fontWeight: "bold",
//             textAlign: "center",
//             height: "51px",
//             margin: 0,
//           }}
//         >

//         </p> */}
//         {/* <div style={{ marginBottom: "100px", background: "#fff" }}><h1>hsdfasdf</h1></div> */}
//         {/* <Banner /> */}
//         <div style={{marginLeft:"200px"}}>
//           <Landingbanner />
          
//         </div>
//         <div style={{marginLeft:"52px"}}>
//           <Landingabout />
//         </div>
//         <br></br>
//       </div>

//     </div>
//   )
// }

// export default Homes















import React from 'react'
import Banner from "../Component/BannerHome"
import Landingabout from "../Component/Modules/Landingmanagment/Landingabout";
import Landingbanner from "../Component/Modules/Landingmanagment/Landingbanner";
import "./Homes.css";
import { Link } from "react-router-dom";

function Homes() {
  return (
    <div>
      <div className=' home-banner-scrolling' 
           style={{ 
             marginTop: "105px", 
             marginBottom: "50px", 
             overflow: "auto", 
             scrollbarWidth: "none",
             width: "100vw",
             marginLeft: 0,
             padding: 0
           }}>
        <div style={{ width: "100%" }}>
          <Landingbanner />
        </div>
        <div style={{ width: "100%" }}>
          <Landingabout />
        </div>
        <br></br>
      </div>
    </div>
  )
}

export default Homes

